// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3tnA7","head":"Table_head__1zy2s","col":"Table_col__3DP4f"};